import React, { useState } from "react";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import classes from "./AddEquipment.module.css";
import { Input } from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import CustomMap from "../../../../CustomMap/CustomMap";
import { Row, Col } from "react-bootstrap";
import { DropDown } from "../../../../../stories/DropDown/DropDown";

export default function AddEquipmentModal({
  show,
  setShow,
  title,
  state,
  setter,
  options,
  onAdd,
}) {
  console.log(
    "aaa",
    options?.map((item) => ({ value: item, label: item }))
  );
  return (
    <>
      <style>{`
            @media screen and (max-width: 580px) {
          .modal .modal-dialog {
            width: 80% !important;
            margin: 0px 10%;
          }
            @media screen and (max-width: 425px) {
          .modal .modal-dialog {
            width: 95% !important;
            margin: 0px auto;

          }
            @media screen and (max-width: 390px) {
              .${classes.heading}{
                max-width:98%;
              }

          }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        borderRadius={"20px"}
        footerStyles={{ padding: "0px", margin: "0px" }}
        width={"570px"}
        header={
          <h4
          className={classes.heading}
            style={{
              ...Fonts.h4,
              fontSize: "26px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            Add {title}
          </h4>
        }
        footer={
          <div className={classes.footerBtns}>
            <Button
              label={"Cancel"}
              primary={false}
              size={"Large"}
              customStyle={{
                width: "95px",
                marginRight: "20px",
                backgroundColor: Colors.white,
                border: "none",
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              onClick={() => setShow(false)}
            />
            <Button
              label={"Add"}
              primary={true}
              size={"Large"}
              customStyle={{
                width: "120px",
                height: "48px",
                ...Fonts.b2,
                lineHeight: "20px",
              }}
              onClick={() => {
                onAdd();
                setShow(false);
              }}
            />
          </div>
        }
      >
        <div className={classes.modalContent}>
          <DropDown
            state={state}
            placeholder=""
            setter={setter}
            isMulti={true}
            options={options?.map((item) => ({ value: item, label: item }))}
            Components={{ DropdownIndicator: () => null }}
            customStyle={{ width: "100%" }}
          />
        </div>
      </ModalSkeleton>
    </>
  );
}
